import React from "react";

const User = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.2793 9.07812C7.36778 8.89671 8.4789 8.89671 9.56738 9.07812L11.668 9.42773C14.0789 9.82956 15.8467 11.9162 15.8467 14.3604V17.167H0V14.3604C0 11.9162 1.76692 9.82966 4.17773 9.42773L6.2793 9.07812ZM9.32031 10.5576C8.39517 10.4035 7.45053 10.4034 6.52539 10.5576L4.4248 10.9072C2.73715 11.1885 1.5 12.6494 1.5 14.3604V15.667H14.3467V14.3604C14.3467 12.6494 13.1095 11.1885 11.4219 10.9072L9.32031 10.5576ZM7.98535 0C9.0894 2.89899e-05 10.035 0.393505 10.8213 1.17969C11.6074 1.96578 12.0008 2.91086 12.001 4.01465L11.9961 4.2207C11.9499 5.23693 11.5582 6.11359 10.8213 6.85059C10.035 7.63685 9.08945 8.03024 7.98535 8.03027L7.78027 8.02539C6.83167 7.98231 6.0051 7.63809 5.2998 6.99316L5.15039 6.85059C4.36418 6.06432 3.9707 5.11875 3.9707 4.01465C3.97089 2.98006 4.31621 2.08458 5.00684 1.3291L5.15039 1.17969C5.93652 0.393668 6.88151 0.000110334 7.98535 0ZM7.98535 1.5C7.28251 1.5001 6.718 1.73328 6.21094 2.24023C5.7039 2.74727 5.47089 3.31187 5.4707 4.01465C5.4707 4.71776 5.70379 5.28284 6.21094 5.79004C6.71805 6.29714 7.28241 6.53017 7.98535 6.53027C8.68846 6.53025 9.25354 6.29724 9.76074 5.79004C10.2678 5.28287 10.501 4.7177 10.501 4.01465C10.5008 3.31188 10.2678 2.74726 9.76074 2.24023C9.25357 1.73312 8.68841 1.50003 7.98535 1.5Z"
      fill={color}
    />
  </svg>
);

User.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default User;
